import { CustomerGroupsGridView } from '~/components/customers/groups';
import { PageContainer } from '~/components/page-container';

export function CustomerGroups() {
	return (
		<PageContainer>
			<CustomerGroupsGridView />
		</PageContainer>
	);
}
